import Progress from 'antd/lib/progress';

import 'antd/lib/progress/style/index.css';

export default Progress;
